module.exports = __webpack_public_path__ + "d716785b6df1eb3436ed0c8b083023df.svg";